import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Services from "@/pages/public/Services";
import Projects from "@/pages/public/Projects";
import ProjectDetail from "@/pages/public/ProjectDetail";
import Contact from "@/pages/public/Contact";
import Configurator from "@/pages/public/Configurator";
import SharedProposal from "@/pages/public/SharedProposal";

import Login from "@/pages/admin/Login";
import AuthCallback from "@/pages/admin/AuthCallback";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminServices from "@/pages/admin/AdminServices";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminProposals from "@/pages/admin/AdminProposals";
import ProposalBuilder from "@/pages/admin/ProposalBuilder";
import ProposalPreviewPage from "@/pages/admin/ProposalPreviewPage";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAccess from "@/pages/admin/AdminAccess";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth return synchronously during render to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        <Route path="/configurator" element={<Configurator />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
      <Route path="/proposal/:shareId" element={<SharedProposal />} />

      <Route path="/admin/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/admin/proposals/:id/preview" element={<ProposalPreviewPage />} />
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/proposals" element={<AdminProposals />} />
          <Route path="/admin/projects" element={<AdminProjects />} />
          <Route path="/admin/services" element={<AdminServices />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/access" element={<AdminAccess />} />
        </Route>
        <Route path="/admin/proposals/:id/edit" element={<ProposalBuilder />} />
        <Route path="/admin/proposals/new" element={<ProposalBuilder />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
